import { c as _c } from "react/compiler-runtime";
import Head from 'next/head';
import { FC } from 'react';
import { ChildrenProps } from '..';
import { appName } from '../theme/theme';
import 'iframe-resizer/js/iframeResizer.contentWindow';
import Image from 'next/image';
import SwiftLogo from '@public/swift-logo-text.png';
export const CraftedChartPage: FC<ChildrenProps & {
  title: string;
  titleShort: string;
  embedded?: boolean;
}> = t0 => {
  const $ = _c(5);
  const {
    children,
    title,
    titleShort,
    embedded
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== embedded || $[2] !== title || $[3] !== titleShort) {
    t1 = embedded ? <>{children}</> : <div className="h-screen overflow-y-auto"><Head><title>{`${appName} - ${titleShort}`}</title></Head><div className="relative m-auto max-w-[70em] flex-col space-y-5 p-10"><div className="flex flex-row justify-between"><h1 className="grow">{title}</h1><div className="shrink-0 grow-0"><Image src={SwiftLogo} alt="Swift logo" className="ml-5 mt-4 w-[7em] opacity-20" /></div></div><div>{children}</div></div></div>;
    $[0] = children;
    $[1] = embedded;
    $[2] = title;
    $[3] = titleShort;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};